function escapeHtml(value) {
  if (value == null) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Convierte marcadores de negrita a HTML seguro.
 * Sintaxis: **texto** o __texto__
 */
export function textoContratoAHtml(texto) {
  if (!texto) return '';

  const partes = String(texto).split(/(\*\*[^*]+?\*\*|__[^_]+?__)/g);

  return partes
    .map((parte) => {
      if (/^\*\*.+\*\*$/.test(parte)) {
        return `<strong>${escapeHtml(parte.slice(2, -2))}</strong>`;
      }
      if (/^__.+__$/.test(parte)) {
        return `<strong>${escapeHtml(parte.slice(2, -2))}</strong>`;
      }
      return escapeHtml(parte).replace(/\n/g, '<br/>');
    })
    .join('');
}

/** Envuelve la selección del textarea con ** para negrita. */
export function envolverSeleccionNegrita(texto, inicio, fin) {
  const contenido = texto || '';
  const start = inicio ?? contenido.length;
  const end = fin ?? start;
  const seleccion = contenido.slice(start, end);

  if (seleccion) {
    const envuelto = `**${seleccion}**`;
    return {
      texto: contenido.slice(0, start) + envuelto + contenido.slice(end),
      cursorInicio: start + 2,
      cursorFin: start + 2 + seleccion.length,
    };
  }

  const token = '**texto**';
  return {
    texto: contenido.slice(0, start) + token + contenido.slice(end),
    cursorInicio: start + 2,
    cursorFin: start + 6,
  };
}

export function aplicarNegritaEnTextarea(textarea, setTexto) {
  if (!textarea) return;

  const inicio = textarea.selectionStart ?? 0;
  const fin = textarea.selectionEnd ?? inicio;
  const { texto, cursorInicio, cursorFin } = envolverSeleccionNegrita(
    textarea.value,
    inicio,
    fin
  );

  setTexto(texto);

  requestAnimationFrame(() => {
    textarea.focus();
    textarea.setSelectionRange(cursorInicio, cursorFin);
  });
}
